import React from 'react';
import axios from 'axios';
import Swal from "sweetalert2";
import 'antd/dist/antd.css';
import { Steps, Button } from 'antd';
import NuovaIniziativa1 from "./nuova-iniziativa-1";
import NuovaIniziativa2 from "./nuova-iniziativa-2";
import NuovaIniziativa3 from "./nuova-iniziativa-3";

export let iniziativaData = { iniziativa : "",uuid: "", categoria : 0 , template : 0, items : [], eventi : []};
const { Step } = Steps;

const steps = [
{
  title: 'Informazioni generali',
  content: <NuovaIniziativa1 />,
  disabled: false,
  //subTitle: "subtitle1",
  // description: "descrizione 1"
},
{
  title: 'Gestione brand',
  content: <NuovaIniziativa2 />,
  disabled: false,
  //subTitle: "subtitle2",
  // description: "descrizione 2"
},
{
  title: 'Assegnazione template',
  content: <NuovaIniziativa3 />,
  disabled: false,
  //subTitle: "subtitle3",
  //description: "descrizione 3"
}];
class NuovaIniziativa extends React.Component { state = { current: 0,};
  
  onChange = current => {
    if (this.state.current === 0){
      if (iniziativaData.categoria === 0 || iniziativaData.iniziativa === null || iniziativaData.iniziativa.length === 0 || iniziativaData.items.length === 0){
        Swal.fire({
          icon: 'error',
          text: 'Inserire tutte le informazioni',
        })
        return
      }
    }
    this.setState({ current });
  };
  next = () => {
    if (this.state.current === 0)
    {
      if (iniziativaData.categoria === 0 || iniziativaData.iniziativa === null || iniziativaData.iniziativa.length === 0 || iniziativaData.items.length === 0)
      {
        Swal.fire({
          icon: 'error',
          text: 'Inserire tutte le informazioni',
        })
        return
      }
    }
    let plus=this.state.current + 1
    this.setState({current: plus})
  }
  prev = () => {
    let minus=this.state.current - 1
    this.setState({current: minus})
  }
  salvainiziativa = () => 
  {
    
      axios.post(process.env.REACT_APP_BASE_URL + 'inserisci-iniziativa', iniziativaData )
      .then(function(response) {
        if (response.status === 200) {
          //history.push("palinsesti?tab=palinsesti-sub")
          Swal.fire({ title:"", text:"Operazione eseguita correttamente",icon:"success"}).then(function() { 
            window.location.href ='palinsesti?tab=iniziative'})
          }
        else {throw new Error(response.status);}
        }).catch(function(error)
        {
          Swal.fire({ title:"", html:"Errore nel salvataggio, esiste già un iniziativa col nome <b>" + iniziativaData.iniziativa + "</b>", icon:"error"})
    });
  }
 
  render() {
    const { current } = this.state;

    return (
    <>   
      <Steps style={{margin: '0 auto', width: '90%'}} type="navigation" className = "nav-steps" current={current} onChange={this.onChange}>
        <Step title="informazioni generali" description="Inserisci le informazioni generali per definire il iniziativa." />
        <Step title="Gestione brand" description="Gestisci la distribuzione dei brand durante i giorni della settimana." />
        <Step title="Impostazione template" description="Seleziona il template da associare al iniziativa che stai creando." />
      </Steps>  
      <div className="nuovo-palinsesto">
        {steps[current].content}
        <div className="steps-actions"> 
          {current > 0 && (<Button className="step-previous" onClick={this.prev} >Indietro</Button>)}
          {current < steps.length - 1 && (<Button type="primary" className="step-next"  onClick={this.next}>Avanti</Button>)}
          {current  === 2 &&( <Button type="primary" className="step-next"  onClick={ this.salvainiziativa }>Salva iniziativa</Button>)}  
        </div> 
      </div>
    </>
    );
  }
}
export {NuovaIniziativa as default, iniziativaData as array};
